import { render } from "./three-column-pitch.vue?vue&type=template&id=b2243b1e&scoped=true&ts=true"
import script from "./three-column-pitch.vue?vue&type=script&lang=ts"
export * from "./three-column-pitch.vue?vue&type=script&lang=ts"

import "./three-column-pitch.vue?vue&type=style&index=0&id=b2243b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2243b1e"]])

export default __exports__